import { render } from "./loader-global.vue?vue&type=template&id=0c9ceda0&scoped=true"
import script from "./loader-global.vue?vue&type=script&lang=js"
export * from "./loader-global.vue?vue&type=script&lang=js"

import "./loader-global.vue?vue&type=style&index=0&id=0c9ceda0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9ceda0"]])

export default __exports__